<script>
import Vue from 'vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: "createFaq",
  data() {
    return {
      submitting: false,
      formFaqDetails: {
        faqId: "",
        question: "",
        answer: "",
        position: "",
        status: "",
      },
      ruleFaqDetails: {
        question: {
          required: true,
          message: "question is mandatory",
          trigger: "blur"
        },
        answer: {
          required: true,
          message: "answer is mandatory",
          trigger: "blur"
        },
        position: {
          required: true,
          message: "position is mandatory",
          trigger: "blur"
        },
      }
    }
  },
  methods: {
    ...mapActions('faq', ['saveFaq', "getFaqById", "updateFaq"]),
    goBack() {
      this.$router.go(-1)
    },
    navigateToAllFaqs() {
      this.$router.push({ path: "/faq/all" });
    },
    initialize() {
      this.formFaqDetails.faqId = this.$route.query.faqId;
    },
    getFaqDetails(faqId) {
      let params = {
        faqId: faqId
      };
      this.getFaqById({ params: params, callback: this.callback });
    },
    createFaq(faqForm){
      this.submitting = true
      this.formFaqDetails.status = "PUBLISHED"
      this.$refs[faqForm].validate(valid => {
        if (valid) {
          this.saveFaq({
            params: {
              question: this.formFaqDetails.question,
              answer: this.formFaqDetails.answer,
              position: this.formFaqDetails.position,
              status: this.formFaqDetails.status,
            },
            callback: this.callback
          })
        } else {
          this.submitting = false
          return false
        }
      })
    },
    modifyFaq(faqForm){
      this.submitting = true
      this.formFaqDetails.status = "PUBLISHED"
      this.$refs[faqForm].validate(valid => {
        if (valid) {
          this.updateFaq({
            params: {
              faqId: this.formFaqDetails.faqId,
              question: this.formFaqDetails.question,
              answer: this.formFaqDetails.answer,
              position: this.formFaqDetails.position,
              status: this.formFaqDetails.status,
            },
            callback: this.callback
          })
        } else {
          this.submitting = false
          return false
        }
      })
    },
    callback(resp, status) {
      switch (status) {
        case "saveFaqCallback":
          if (resp.code == 0) {
            this.submitting = true;
            this.navigateToAllFaqs()
            this.formFaqDetails = resp.data
            Utils.alert('', 'FAQ Created Successfully!', 'success')
            this.submitting = false;
          } else {
            this.submitting = false;
            Utils.alert('', resp.message, 'error')
          }
          break;
        case "getFaqByIdCallback":
          if (resp.code == 0) {
            this.formFaqDetails.faqId = resp.data.faqId;
            this.formFaqDetails.question = resp.data.question;
            this.formFaqDetails.answer = resp.data.answer;
            this.formFaqDetails.position = resp.data.position;
            this.formFaqDetails.status = resp.data.status;
          }
          break;
        case "updateFaqCallback":
          if (resp.code == 0) {
            this.submitting = true;
            Utils.alert('', 'FAQ Updated Successfully!', 'success')
            this.$router.push({ path: "/faq/all" });
            this.submitting = false;
          } else {
            this.submitting = false;
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          this.submitting = false;
          break;
      }
    }
  },
  mounted() {
    this.initialize()
    let faqId = this.$route.query.faqId;
    if (faqId) {
      this.getFaqDetails(faqId)
    }
  }
})
</script>

<template>
  <div class="referrer_box">
    <el-row>
      <el-col :span="12">
        <div v-if="this.$route.query.faqId == null" class="faq-title">
          Create FAQ
        </div>
        <div v-else class="faq-title">
          Edit FAQ
        </div>
      </el-col>
      <el-col :span="12" class="back-col">
        <div
          @click="goBack()"
          class="back-btn"
        >
          <i class="el-icon-arrow-left" style="font-weight: bolder;"></i
          >BACK
        </div>
      </el-col>
    </el-row>
    <el-form
      :model="formFaqDetails"
      :label-position="'top'"
      :rules="ruleFaqDetails"
      :hide-required-asterisk="true"
      @submit.native.prevent
      ref="formFaqDetails"
      label-width="250px"
      class="addruleForm"
    >
      <el-row>
        <el-col :span="24" style="margin-top: 20px">
          <div class="textFieldsStyle">Question</div>
          <el-input
            placeholder="Question..."
            maxlength="1000"
            type="textarea"
            :rows="2"
            show-word-limit
            v-model="formFaqDetails.question"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-top: 10px">
          <div class="textFieldsStyle">Answer</div>
          <el-input
            placeholder="Answer..."
            maxlength="100000"
            type="textarea"
            :rows="10"
            v-model="formFaqDetails.answer"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-top: 10px">
          <div class="textFieldsStyle">Position</div>
          <el-input
            placeholder="Position..."
            type="number"
            v-model="formFaqDetails.position"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding-top: 20px; margin-top: 20px" >
        <el-col :span="20">
          <el-button
            @click="navigateToAllFaqs"
            type="text" class="btn-cancel"
          >
            Cancel
          </el-button>
        </el-col>
        <el-col :span="4">
          <el-button class="btn-create-faq" v-if="this.$route.query.faqId == null"
                     @click="createFaq('formFaqDetails')"
          >
            Create FAQ
            <i v-if="submitting" class="el-icon-loading"></i>
          </el-button>
          <el-button class="btn-create-faq" v-else
                     @click="modifyFaq('formFaqDetails')"
          >
            Update FAQ
            <i v-if="submitting" class="el-icon-loading"></i>
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<style scoped>
.referrer_box {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}
.faq-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}
.back-col {
  display: flex;
  justify-content: flex-end;
}
.back-btn {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
  text-decoration: underline;
  cursor: pointer;
}
.textFieldsStyle {
  padding-bottom: 5px;
}

.btn-create-faq {
  color: #ffffff;
  border: 4px solid #003333;
  background-color: #003333;
  padding: 10px 0;
  font-weight: 600;
  font-size: 20px;
  width: 100%;
}
.btn-cancel {
  border-bottom: 1px solid #003333;
  padding-bottom: 2px;
  border-radius: 0;
  color: #003333;
  font-weight: 600;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/faq/createFaq.vue